import {
  Directive,
  HostListener,
  HostBinding,
  ViewChild,
  ElementRef
} from '@angular/core';

@Directive({
  selector: '[appDropdown]'
})

export class DropdownDirective {


  @ViewChild('ul.is-dropdown-submenu', { read: ElementRef }) private dropdownSubmenu: ElementRef;

  @HostBinding('class.is-active') isOpen = false;

  @HostListener('click') toggleClass() {
    this.isOpen = !this.isOpen;
    this.dropdownSubmenu.nativeElement.classList.add('js-dropdown-active');
  }


}